// extracted by mini-css-extract-plugin
export default {"container":"R1xS7M","heading":"XFbstC","buttonWrapper":"VAYgdR","button1":"dTIpwz","button2":"xs6cKg","button":"RArf0e"};